<template>
  <div>
    <el-collapse v-model="activeNames">
      <el-collapse-item title="数据源" name="1">
        <cx-slider class="mb12" :value.sync="noCacheComponent" :options="dataOptions" :height="32" />
        <div class="data-source-type">
          <div v-show="!noCacheComponent"  class="dataSource-item" @click="goToChooseData">
            <span>进入数据管理后台 </span>
          </div>
          <data-center-choose
            v-show="noCacheComponent"
            :checkStatus="checkStatus"
            :myId="ids"
            :getId="getId"
            :options="options"
            type="chart_screen"
            :extraQuery="extraQuery"
            @onDataCenterChange="onDataCenterChange"
            @onAfterDataCenterChoose="onAfterDataCenterChoose"
          />
        </div>
      </el-collapse-item>
      <el-collapse-item title="数据源" name="1">
        <div class="data-source-type">
          <auto-update-timer :isLocal="false" type="chart_screen"/>
          <div class="mt12">
            <!-- <div class="getDataBtn mb12" @click="getBaseModuleDataLoop">查看数据响应结果</div> -->
            <el-button
              v-if="restDataUrl && request_prefix === 'bigScreen'"
              class="clear-url-btn mb16"
              @click="clearRestDataUrlFunc"
              >清空数据源</el-button
            >
            <cx-check-box v-if="request_prefix==='bigScreen'" :value.sync="usePageQuery">开启跨页面传参</cx-check-box>
          </div>
        </div>
        <edit-table @change="updateTableData" :tableData="formateLinesData"></edit-table>
      </el-collapse-item>
    </el-collapse>
  </div>
</template>

<script>
import allChartDataHandle from "@/utils/updateData/chart/index.js"
import { bs_text_children, text_children, app_text_children } from "materials/text/menus/index.js"
import { findCurrentComponentPathInLayoutByRectId } from "@/utils"
import autoUpdateTimer from "components/toolbar-option-components/utilsComponents/autoUpdateTimer/autoUpdateTimer.vue"
import dataCenterChoose from "publicSetting/dataCenterChoose.vue"
export default {
  components: {
    autoUpdateTimer,
    dataCenterChoose
  },
  data() {
    return {
      activeNames: ["1"],
      this1: this,
      fetchEnd: false,
      dataOptions: [{ value: false, title: "本地数据" }, { value: true, title: "数据中心" }]
    }
  },
  props: {
    options: Object
  },
  computed: {
    ids() {
      return this.$store.state.states.activeID
    },
    chartOption() {
      return this.options.chartOption
    },
    linesData() {
      return this.chartOption.lines.data || []
    },
    noCacheComponent: {
      get() {
        return this.options && this.options.noCacheComponent ? this.options.noCacheComponent : false
      },
      set(newVal) {
        // 切换到本都数据的时候，清除之前绑定的appId
        if(!newVal){
          this.$changeOptionsEV('', "appId", false)
        }
        this.$changeOptionsEV(newVal, "noCacheComponent", false, null)
      }
    },
    formateLinesData() {
      const res = []
      this.linesData
        .filter(item => item)
        .forEach((item, index) => {
          if (index === 0) {
            res.push([
              ["name", item[0].value],
              ["x", item[0].coord[0]],
              ["y", item[0].coord[1]],
              ["", "中心点坐标"]
            ])
          } else {
            res.push([
              ["name", item[0].value],
              ["x", item[0].coord[0]],
              ["y", item[0].coord[1]]
            ])
          }
        })
      return res
    },
    restDataUrl: {
      get() {
        return (
          this.getAttrById(this.$store.state[this.request_prefix], this.lineMapRectIds, "rect")?.options?.restDataUrl ||
          ""
        )
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "restDataUrl", false, null, this.lineMapRectIds)
      }
    },
    linesHasDataUrl: {
      get() {
        return this.checkAndSetPrimaryVal(this.chartOption, "linesHasDataUrl", "linesHasDataUrl", false)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "chartOption.linesHasDataUrl", false)
      }
    },
    lineMapRectIds() {
      return {
        container_id: this.ids.container_id,
        rect_id: this.lineMapRectId
      }
    },
    usePageQuery: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "usePageQuery", "usePageQuery", false)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "usePageQuery", false)
      }
    },
    lineMapRectId: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "lineMapRectId", "lineMapRectId", -1)
      },
      set(val) {
        this.$changeOptionsEV(val, "lineMapRectId", false)
      }
    },
    checkStatus() {
      return this.options.appId
    },
    extraQuery() {
      return this.lineMapRectId !== -1
    }
  },
  mounted() {
    this.$eventBus.$on("update-toolbar-data", this.updateToolbarData)
  },
  beforeDestroy() {
    this.$eventBus.$off("update-toolbar-data", this.updateToolbarData)
  },
  methods: {
    collapseMouseDown($event, val) {
      if ($event.target.classList[0] === "el-collapse-item__header") {
        const _index = this.collapseActiveNames.findIndex(it => it === val)
        _index === -1 ? this.collapseActiveNames.push(val) : ""
      }
    },
    goToChooseData() {
      const newComponentRectId = this.createTransparentComponent()
      let newIds = { container_id: this.ids.container_id, rect_id: newComponentRectId }
      if (this.fetchEnd) return
      this.fetchEnd = true
      const { websiteId, pageId, sign, wfwfid } = this.$store.state.states.getDataPageIds
      let rectAttr = null
      if (this.lineMapRectId === -1) {
        rectAttr = this.getAttrById.call(this, this.$store.state[this.request_prefix], this.ids)
      } else {
        rectAttr = this.getAttrById.call(this, this.$store.state[this.request_prefix], newIds)
      }
      let { moduleId, appId } = rectAttr
      if (moduleId === undefined) moduleId = rectAttr?.options?.moduleId
      if (appId === undefined) appId = rectAttr?.options?.appId
      if ((!moduleId || !appId) && this.lineMapRectId !== -1) {
        this.$saveModule(newIds, "31CB73E03E24BBFF", "临时", true)
          .then(res => {
            this.fetchEnd = false
            if (res.appId) {
              // 模板问题，第一次需要手动将数据源切换为本地数据
              this.$API.setLocalData({ appId: res.appId, type: "chart_screen" }).then(() => {
                window.open(`/engine2/data/api-v2/admin/chart_screen/${res.appId}?w=${websiteId}&p=${pageId}&hideDataContent=true`)
                this.restDataUrl = `engine2/data/api-v2/chart/${res.appId}/data`
              })
            }
          })
          .catch(err => (this.fetchEnd = false))
      }
      this.fetchEnd = false
      if (appId) window.open(`/engine2/data/api-v2/admin/chart_screen/${appId}?w=${websiteId}&p=${pageId}&hideDataContent=true`)
      this.restDataUrl = `engine2/data/api-v2/chart/${appId}/data`
      this.linesHasDataUrl = true
    },
    async getBaseModuleDataLoop() {
      let newIds = JSON.parse(JSON.stringify(this.ids))
      //  地图在自由布局中的情况
      if (newIds.uid) {
        delete newIds.uid
      }
      if (newIds.elementInLayoutId || newIds.elementInLayoutId === 0) {
        delete newIds.elementInLayoutId
      }
      newIds.rect_id = this.lineMapRectId
      const rectAttr = this.getAttrById.call(this, this.$store.state[this.request_prefix], newIds).options
      let { appId } = rectAttr
      if (
        this.restDataUrl &&
        this.restDataUrl.length &&
        this.restDataUrl.slice(this.restDataUrl.indexOf("chart") + 6, -5) !== appId
      ) {
        this.restDataUrl = `engine2/data/api-v2/chart/${appId}/data`
      }
      if (!this.restDataUrl) return
      this.linesHasDataUrl = true
      const { websiteId, pageId } = this.$store.state.states.getDataPageIds
      let str = "?w=" + websiteId + "&p=" + pageId
      this.instance.get(this.restDataUrl + str).then(res => {
        allChartDataHandle.handleLineData.call(this, this.options.chartOption, res)
      })
    },
    updateTableData(type, rowIndex, colKey, key, value) {
      if (colKey < 3) {
        if (type === "update") {
          let changeKey = "chartOption.lines.data." + rowIndex
          switch (key) {
            case "name":
              changeKey = changeKey + ".0.value"
              break
            case "x":
              changeKey = changeKey + ".0.coord.0"
              break
            case "y":
              changeKey = changeKey + ".0.coord.1"
              break

            default:
              break
          }
          // 如果改的是第一条数据那么中心点位置跟着改
          let newLinesData = JSON.parse(JSON.stringify(this.linesData))
          let newCenterData = JSON.parse(JSON.stringify(this.chartOption.lines.centerData))
          if (rowIndex === 0 && colKey === 1) {
            for (let i = 0; i < this.linesData.length; i++) {
              newLinesData[i][1].coord[0] = value
            }
            newCenterData.center[0] = value
          } else if (rowIndex === 0 && colKey === 2) {
            for (let i = 0; i < this.linesData.length; i++) {
              newLinesData[i][1].coord[1] = value
            }
            newCenterData.center[1] = value
          } else if (rowIndex === 0 && colKey === 0) {
            newCenterData.name = value
            newLinesData[rowIndex]
          }
          if (rowIndex === 0) {
            this.$changeOptionsEV(newCenterData, "chartOption.lines.centerData", false, false, false, true)
            this.$changeOptionsEV(newLinesData, "chartOption.lines.data", false, false, false, true)
          }
          this.$changeOptionsEV(value, changeKey, false, false, false, true)
          this.$nextTick(this.checkData)
        } else {
          const changeKey = "chartOption.lines.data." + this.linesData.length
          const changeValue = [{}, { coord: [...this.linesData[0][1].coord] }]
          switch (colKey) {
            case 0:
              changeValue[0].value = value
              changeValue[0].coord = [undefined, undefined]
              break
            case 1:
              changeValue[0].value = ""
              changeValue[0].coord = [value, undefined]
              break
            case 2:
              changeValue[0].value = ""
              changeValue[0].coord = [undefined, value]
              break

            default:
              break
          }
          this.$changeOptionsEV(changeValue, changeKey, false, false, false, true)
        }
      } else if (type === "delete" && typeof rowIndex === "number") {
        const newLinesData = JSON.parse(JSON.stringify(this.linesData))
        newLinesData.splice(rowIndex, 1)
        this.$changeOptionsEV(newLinesData, "chartOption.lines.data", false, false, false, true)
      } else {
        this.$message({
          type: "error",
          customClass: "bigScreen_msg_backGroud",
          duration: 3000,
          message: "该列数据为无效数据，请勿修改"
        })
      }
    },
    checkData() {
      let needUpdate = false
      const newLinesData = []
      this.linesData.forEach(item => {
        if (!item || !item[0].hasOwnProperty("value") || !item[0].hasOwnProperty("coord")) {
          needUpdate = true
        } else {
          newLinesData.push(JSON.parse(JSON.stringify(item)))
        }
      })
      if (needUpdate) {
        this.$changeOptionsEV(newLinesData, "chartOption.lines.data", false, false, false, true)
      }
    },
    createTransparentComponent() {
      // 添加一个隐藏组件,记录rect_id为了外接数据源发送请求
      if (this.lineMapRectId === -1) {
        let newTextOpt
        if (this.request_prefix === "bigScreen") {
          newTextOpt = JSON.parse(JSON.stringify(bs_text_children[0].attribute))
        } else if (this.request_prefix === "stage") {
          newTextOpt = JSON.parse(JSON.stringify(text_children[0].attribute))
        } else if (this.request_prefix === "appStage") {
          newTextOpt = JSON.parse(JSON.stringify(app_text_children[0].attribute))
        }
        newTextOpt.options.width = 0
        newTextOpt.options.height = 0
        newTextOpt.options.opacity = 0
        newTextOpt.options.left = 0
        newTextOpt.options.top = 0
        // 左侧图层树结构隐藏属性
        newTextOpt.options.hideInLayerTree = true
        const params = {
          containerID: this.ids.container_id,
          data: newTextOpt
        }
        this.$store.dispatch(this.request_prefix + "/addElement", params)
        this.$changeOptionsEV(params.data.rect_id, "lineMapRectId", false, false, false, true)
        if (this.request_prefix !== "bigScreen") {
          // 查找当前通栏的路径
          const path = findCurrentComponentPathInLayoutByRectId(
            this.$store.state[this.request_prefix].page.pageLayoutList,
            this.ids.rect_id
          ).join("_")
          const stage = this.$store.state[this.request_prefix]
          let pageLayout = this.getAttrById(stage, { pageLayoutId: path }, "pageLayout")
          pageLayout.rectIds.push(params.data.rect_id)
          let param = {
            ...this.ids,
            option_name: "rectIds",
            option_val: pageLayout.rectIds
          }
          this.$store.dispatch(this.request_prefix + "/changeOptions", param)
        }
        return params.data.rect_id
      } else {
        return this.lineMapRectId
      }
    },
    // 清空自由布局外接数据源地址与数据
    clearRestDataUrlFunc() {
      this.$confirm("确认清空数据源？", "", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning",
        showClose: false,
        iconClass: `${this.request_prefix}_confirm_icon el-icon-warning`,
        cancelButtonClass: `${this.request_prefix}_confirm_cancel_button`,
        confirmButtonClass: `${this.request_prefix}_confirm_button`,
        customClass: `${this.request_prefix}_confirm custom_warning_dialog`
      })
        .then(() => {
          //基础组件还原为默认的
          this.clearData()
          this.$message({
            type: "success",
            duration: 2000,
            message: "清空成功!"
          })
        })
        .catch(action => {
          if (action === "cancel") return
          this.$message({
            type: "info",
            message: "清空失败"
          })
        })
    },
    //清空组件数据
    clearData() {
      this.linesHasDataUrl = false
      this.restDataUrl = ""
      let emptyDataLists = [
        { name: "appId", value: "" },
        { name: "moduleId", value: "" },
        { name: "typeId", value: "" }
      ]
      for (let i = 0; i < emptyDataLists.length; i++) {
        this.$changeOptionsEV(emptyDataLists[i].value, emptyDataLists[i].name, false, null, this.lineMapRectIds, true)
      }
      this.$changeOptionsEV([], "chartOption.lines.data", false, false, false, true)
    },
    getLinesData() {
      const name = this.chartOption.name
      const mapName = name === "全国" ? "china" : name.split("/").reverse()[0]
      const allCity = this.$echarts.getMap(mapName).geoJSON.features
      const centerCode = [...allCity[0].properties.center]
      const geoCoord = allCity
        .map(it => {
          if (
            !it?.properties?.center?.length ||
            (it.properties.center[0] === centerCode[0] && it.properties.center[1] === centerCode[1])
          ) {
            return undefined
          } else {
            return [
              {
                value: it.properties.name,
                coord: it.properties.center
              },
              { coord: centerCode }
            ]
          }
        })
        .filter(it => {
          return it !== undefined && it[0].coord
        })
      this.$changeOptionsEV(geoCoord, "chartOption.lines.data", false, null, this.myid, true)
      this.$changeOptionsEV(allCity[0].properties, "chartOption.lines.centerData", false, null, this.myid, true)
      // 补全第一条飞线中心点
      if (
        allCity[allCity.length - 1].properties.name === "" &&
        allCity.length - 1 !== this.chartOption.lines.data.length
      ) {
        let newlinesData = JSON.parse(JSON.stringify(this.chartOption.lines.data))
        newlinesData.unshift([
          {
            value: allCity[0].properties.name,
            coord: allCity[0].properties.center
          },
          {
            coord: allCity[0].properties.center
          }
        ])
        this.$changeOptionsEV(newlinesData, "chartOption.lines.data", false, null, this.myid, true)
      } else if (
        allCity[allCity.length - 1].properties.name !== "" &&
        allCity.length !== this.chartOption.lines.data.length
      ) {
        let newlinesData = JSON.parse(JSON.stringify(this.chartOption.lines.data))
        newlinesData.unshift([
          {
            value: allCity[0].properties.name,
            coord: allCity[0].properties.center
          },
          {
            coord: allCity[0].properties.center
          }
        ])
        this.$changeOptionsEV(newlinesData, "chartOption.lines.data", false, null, this.myid, true)
      }
    },
    getId() {
      const newComponentRectId = this.createTransparentComponent()
      let newIds = { container_id: this.ids.container_id, rect_id: newComponentRectId }
      return this.lineMapRectId === -1 ? this.ids : newIds
    },
    onDataCenterChange() {
      this.getBaseModuleDataLoop()
    },
    onAfterDataCenterChoose(appId) {
      this.restDataUrl = `engine2/data/api-v2/chart/${appId}/data`
      this.linesHasDataUrl = true
    },
    updateToolbarData() {
      this.getBaseModuleDataLoop()
    }
  }
}
</script>

<style lang="scss" scoped>
.dataSource-item {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 32px;
  background: var(--leftMenuBgColor);
  border: 1px solid var(--themeColor);
  border-radius: 4px;
  font-size: 14px;
  color: var(--themeColor);
  &:hover {
    cursor: pointer;
  }
}
.getDataBtn {
  background: var(--themeColor);
  border-radius: 4px;
  font-size: 14px;
  line-height: 20px;
  text-align: center;
  color: #ffffff;
  padding: 6px 0px;
}
.getDataBtn:hover {
  cursor: pointer;
}
</style>
